import depositListTemplate from './depositList.html';

/*--------------------------------------------*/
/* Grid object used to restore the grid state */
/* when the user returns to the main page.    */
/*--------------------------------------------*/
var mSavedState = null;

/*------------------------------------------------------*/
/* Deposit being viewed. Used when restoring the state. */
/*------------------------------------------------------*/
var mSelectedDep = null;

/*****************************************************************************
 * DepositList */
/**
 * @ngdoc   component
 * @module  depositHistory
 * @name    depositHistory.component:DepositList
 * @description
 * Displays a list of Deposits for the organization. The Deposits are
 * grouped in the grid by the bank account, and if a default bank account has been
 * set, the default group will be opened upon app initialization. Each row will
 * show important information about the Deposits statement. An action
 * column contains buttons for viewing more detail and printing the details.
 *****************************************************************************/
export const depositListComponent = {
  template: depositListTemplate,
  controller: DepositListController,
  bindings: { isBoosterpta: '<', accountName: '<' }
};

/*******************************************************************************
 * DepositListController */
/**
 * Controller for the {@link depositHistory.component:DepositList DeposittList}
 * component.
 *******************************************************************************/
/* @ngInject */ function DepositListController(
  $injector,
  $scope,
  $timeout,
  BusyScreen,
  DepositHistoryService,
  uiGridConstants
) {
  /*****************************************************************************
   * Properties
   *****************************************************************************/
  /** Controller Instance Reference. */ var mThis = this;
  /** Print dialog is open. */ var mPrintDialogOpen = false;

  /*--------------*/
  /* Injectorlist */
  /*--------------*/
  mThis.viewDeposit = $injector.invoke(viewDeposit, null, {
    mThis: mThis,
    $scope: $scope
  });
  mThis.printDeposit = $injector.invoke(printDeposit, null, {
    mThis: mThis,
    $scope: $scope
  });

  /*--------------------*/
  /* Initialize the app */
  /*--------------------*/
  mThis.$onInit = function () {
    /*----------------------------------------------------------*/
    /* Template for the actions options added to each grid row. */
    /*----------------------------------------------------------*/
    var actionsCellTemplate =
      '<div class="ui-grid-cell-contents " ng-show="row.entity.entryDate != null">' +
      '<span class="pointer glyphicon glyphicon-search csm-grid-space-target" title="View Deposit"  ng-click="grid.appScope.$ctrl.viewDeposit(row.entity)"></span> &nbsp;' +
      '<span class="pointer glyphicon glyphicon-print  csm-grid-space-target" title="Print Deposit" ng-click="grid.appScope.$ctrl.printDeposit(row.entity.id)"></span> &nbsp;' +
      '</div>';

    /*----------------------------------------------------*/
    /* Template to add double click functionality to each */
    /* grid row. Begins editing the double clicked event. */
    /*----------------------------------------------------*/
    var dblClickTemplate =
      '<div ng-dblclick="grid.appScope.$ctrl.viewDeposit(row.entity)" ng-repeat="(colRenderIndex, col) in colContainer.renderedColumns track by col.colDef.name" class="ui-grid-cell" ui-grid-cell></div>';

    /*--------------*/
    /* Grid Options */
    /*--------------*/
    mThis.dgStatements = {
      enableColumnMenus: false,
      enableFullRowSelection: true,
      enableRowHeaderSelection: false,
      enableSorting: false,
      enableHorizontalScrollbar: uiGridConstants.scrollbars.WHEN_NEEDED,
      enableVerticalScrollbar: uiGridConstants.scrollbars.WHEN_NEEDED,
      onRegisterApi: function (gridApi) {
        mThis.dgStatements.api = gridApi;
      },
      groupingShowCounts: false,
      multiSelect: false,
      saveGroupingExpandedStates: true,
      rowTemplate: dblClickTemplate,
      data: [],
      columnDefs: [
        {
          displayName: mThis.accountName,
          field: 'accountName',
          grouping: { groupPriority: 1 },
          width: 200,
          cellTooltip: true
        },
        {
          displayName: 'Date',
          field: 'entryDate',
          cellFilter: "date:'MM/dd/yyyy'",
          width: 100,
          cellClass: 'grid-align'
        },
        {
          displayName: 'Memo',
          field: 'memo',
          cellTooltip: true
        },
        {
          displayName: 'Checks Amt',
          field: 'totalAmountChecks',
          type: 'number',
          cellFilter: 'number:2',
          width: 90,
          cellClass: 'grid-align'
        },
        {
          displayName: 'Cash',
          field: 'totalAmountCash',
          type: 'number',
          cellFilter: 'number:2',
          width: 90,
          cellClass: 'grid-align'
        },
        {
          displayName: 'Total Amt',
          field: 'totalAmount',
          type: 'number',
          cellFilter: 'number:2',
          width: 90,
          cellClass: 'grid-align'
        },
        { displayName: 'Receipts', field: 'totalNumberReceipts', width: 90 },
        { displayName: 'Checks', field: 'totalNumberChecks', width: 90 },
        /*---------*/
        /* Actions */
        /*---------*/
        {
          cellTemplate: actionsCellTemplate,
          enableSorting: false,
          field: 'actions',
          cellClass: 'grid-align-center',
          displayName: 'Actions',
          width: 100
        }
      ]
    };

    BusyScreen.promise(
      DepositHistoryService.getDepositList()
        .then(function (data) {
          mThis.dgStatements.data = data;

          // Force the grid to recompute its viewport against the 80vh container
          $timeout(function () {
            mThis.dgStatements.api.core.handleWindowResize();
          });
        })
        .then(DepositHistoryService.getDefaultBank)
        .then(function (data) {
          var defaultBank = data;

          /*---------------------------------------------------*/
          /* If there is a saved state, restore the grid state */
          /* and scroll to the deposit that was being viewed.  */
          /*---------------------------------------------------*/
          if (mSavedState) {
            mThis.dgStatements.api.saveState.restore(
              mThis.dgStatements,
              mSavedState
            );
            var row = mThis.dgStatements.data.find(function (rows) {
              return rows.id == mSelectedDep.id;
            });

            /*--------------------------------------*/
            /* Timeout is necessary so the grid can */
            /* be rendered before trying to scroll. */
            /*--------------------------------------*/
            $timeout(function () {
              mThis.dgStatements.api.cellNav.scrollToFocus(row);
            });
          } else if (defaultBank) {
            /*----------------------------------------*/
            /* On the initial page load, if there is  */
            /* a default bank, expand that selection. */
            /*----------------------------------------*/
            var group =
              mThis.dgStatements.api.grid.grouping.groupingHeaderCache[
                defaultBank.accountName
              ];
            mThis.dgStatements.api.treeBase.expandRow(group.row);
          }
        })
    );
  };

  /***************************************************************************
   * viewDeposit */
  /**
   * @ngdoc     method
   * @module    depositHistory
   * @methodof  depositHistory.controller:DepositListController
   * @name      viewDeposit
   *
   * @param  {Object}  deposit  Deposit to view details of.
   *
   * @description
   * Handles the view action. Loads the deposit and details.
   ***************************************************************************/
  /* @ngInject */ function viewDeposit($location) {
    return function (deposit) {
      if (!deposit || !deposit.id) return;

      mSavedState = mThis.dgStatements.api.saveState.save();
      mSelectedDep = deposit;
      $location.path('/view/' + deposit.id);
    };
  }

  /*************************************************************************
   * printDeposit */
  /**
   * @ngdoc     method
   * @module    printDeposit
   * @methodof  printDeposit.controller:DepositHistorytListController
   * @name      printStatement
   *
   * @param  id  ID of the deposit to print.
   *
   * @description
   * Handles the print action. The print dialog will be displayed to allow
   * selection of the report type and detail option.
   *************************************************************************/
  /* @ngInject */ function printDeposit(PrintDeposit) {
    return function (id) {
      if (!id) return;

      mPrintDialogOpen = true;
      PrintDeposit.show(id, mThis.isBoosterpta).finally(function () {
        mPrintDialogOpen = false;
      });
    };
  }
}
